export const PERSONAL_SUBMIT_FORM = 'personal_submit_form'
export const SET_PDPA_FLAG = 'set_pdpa_flag'
export const VERIFY_PERSONAL_BEGIN = 'verify_personal_begin'
export const VERIFY_PERSONAL_SUCCESS = 'verify_personal_success'
export const VERIFY_PERSONAL_ERROR = 'verify_personal_error'
export const GET_PERSONAL_PROFILE_SUCCESS = 'get_personal_profile_success'
export const CLEAR_PERSONAL_FORM = 'clear_personal_form'